/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Details ansehen`
};

const en_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `See details`
};

const es_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Ver detalles`
};

const fr_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Voir le détail`
};

const it_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi dettagli`
};

const nl_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Zie details`
};

const pt_poicard__seedetails2 = /** @type {(inputs: {}) => string} */ () => {
	return `Ver detalhes`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const poicard__seedetails2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poicard__seedetails2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poicard__seedetails2", locale)
	if (locale === "de") return de_poicard__seedetails2(inputs)
	if (locale === "en") return en_poicard__seedetails2(inputs)
	if (locale === "es") return es_poicard__seedetails2(inputs)
	if (locale === "fr") return fr_poicard__seedetails2(inputs)
	if (locale === "it") return it_poicard__seedetails2(inputs)
	if (locale === "nl") return nl_poicard__seedetails2(inputs)
	return pt_poicard__seedetails2(inputs)
};
export { poicard__seedetails2 as "poiCard__seeDetails" }